const prefixes = [
    'Congressman',
    'Congresswoman',
    'Dr.',
    'Father',
    'Hon.',
    'Lt. Col.',
    'Mr.',
    'Mr. and Mrs.',
    'Miss',
    'Ms.',
    'Mrs.',
    'Prof.',
    'Rep.',
    'Rev.',
    'Sentator',
];

export default prefixes;
